import React, { useEffect, useMemo, useState } from 'react';
import {Button,Table,Tabs,Spin,Modal,Input} from 'antd';
import {
    AgrialertCopyIcon,
    AgrialertDeleteIcon,
    AgrialertEditIcon,
    AgrialertEditDisabledIcon,
    AgrialertDeleteDisabledIcon,
    AgrialertTemplateCopySvg,
} from '@/resource/IconComponentSets';
import './index.less';
import { updateTemplateType,updateTempDetails, updateSubscriptionDetails,
    updateTab, updatePreviewDetails, updateAllBanner} from '@/redux/reducer/agrialertTemplate';
import { TemplateEnumType } from '@/util/Request/agrialert/responseType';
import {
    agriAlertGetCurrentUser,
    getTemplateDetail,
    deleteTemplate,
    copyTemplate,
    getActiveSubscriptions,
    getAllTemplates,
    getMyTemplates,
    getMySubscriptions,
    deleteSubscription,
    getSubscriptionDetail,
    checkIsValidTempOrSubName,
    getAllBanners
} from '@/util/Request/agrialert';
import IF from '@/components/IF';
import {
    AgrialertUserManagementDeleteSvg,
    AgrialertUserManagementSuccessSvg
} from '@/resource/IconComponentSets';
import { updateSuccessMessage, updateWarningMessage } from '@/redux/reducer/common';
import { deleteTemplateReqModel,deleteSubscriptionReqModel, IForecastChartOrTableModel } from '@/util/Request/agrialert/requestType';
import { RootState } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import HeaderSearchAgrialert from '@/components/HeaderSearchAgrialert';
import TemplatePreview from '../template-preview';
import { debounce } from '@/util/commonFunction';
const TemplateList = ()=>{
    const dispatch = useDispatch();
    const selectedTemplateType = useSelector((state: RootState) => state.agrialertTemplate.templateType);
    const initTab = useSelector((state: RootState) => state.agrialertTemplate.tab);
    const currentRoleId = useSelector((state: RootState) => state.agrialertTemplate.currentRoleId);
    const currentUserId = useSelector((state: RootState) => state.agrialertTemplate.currnetUserId);
    const [searchText, setSearchText] = useState<string>('');
    const [pageIndex, setpageIndex] = useState<number>(1);
    const [tempList, setTempList] = useState([] as any);
    const [myTempList, setMyTempList] = useState([] as any);
    const [avaSubscriptionsList, setAvaSubscriptionsListList] = useState([] as any);
    const [myScriptionsList, setMySubscriptionsListList] = useState([] as any);
    const [isShowAllTemp, setIsShowAllTemp] = useState<boolean>(false);
    const [isShowMyTemp, setIsShowMyTemp] = useState<boolean>(false);
    const [isShowAllSub, setIsShowAllSub] = useState<boolean>(false);
    const [isShowAvaSub, setIsShowAvaSub] = useState<boolean>(false);
    const [isShowMySub, setIsShowMySub] = useState<boolean>(false);
    const [tab, setTab] = useState<number>(1);

    const columnForTemp = useMemo(()=>{
        const columns = [
            {
                // eslint-disable-next-line max-len
                title: 'Name of the Templates',
                dataIndex: 'templateName',
                key: 'templateName',
                sorter: (a, b) => a.templateName.localeCompare(b.templateName),
                render: (text, record, index) =>
                    <a style={{textDecoration:'underline'}} onClick={e => editItem(record)}>{text}</a>
            },
            {
                title: 'Date Created',
                dataIndex: 'templateCreateTime',
                sorter: (a, b) => new Date(a.templateCreateTime).getTime() - new Date(b.templateCreateTime).getTime(),
                render: (_, { templateCreateTime }) => {
                    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                    const date = new Date(templateCreateTime);
                    const year = date.getFullYear().toString().slice(-2);
                    const monthIndex = date.getMonth();
                    const monthAbbrev = months[monthIndex];
                    const day = date.getDate().toString().padStart(2, '0');
                    return `${day}-${monthAbbrev}-${year}`;
                }
            },
            {
                title: 'Create by',
                dataIndex: 'createdByUserName',
                key: 'createdByUserName',
                sorter: (a, b) => a.createdByUserName.localeCompare(b.createdByUserName),
            },
            {
                title: 'Email Recipients',
                dataIndex: 'toEmails',
                key: 'toEmails',
                className: (tab === 3) ? 'to-email-column' : 'hide-column',
                sorter: (a, b) => a?.toEmails?.localeCompare(b?.toEmails),
            },
            {
                title:'Status',
                dataIndex: 'templateIsActive',
                className: tab === 3 ? 'hide-column' : '',
                render: (_, { templateIsActive }) => {
                    let color: string;
                    let staus: string;
                    if (templateIsActive) {
                        color = 'activecircle';
                        staus = 'Active';
                    } else {
                        color = 'inactivecircle';
                        staus = 'Inactive';
                    }
                    return (
                        <div className='status-div'>
                            <div className={color} key={templateIsActive}></div>
                            {staus}
                        </div>
                    );
                },
                filters: [
                    {
                        text: 'Active',
                        value: 'Active',
                    },
                    {
                        text: 'Inactive',
                        value: 'Inactive',
                    }
                ],
                onFilter: (value, record) => (record.templateIsActive==true?'Active':'Inactive').startsWith(value as string)
            },
            {
                title: '',
                dataIndex: 'createdByUserId',
                key: 'createdByUserId',
                render: (text, record, index) => (
                    <div className='txt-right'>
                        <IF show={(currentRoleId===1||currentRoleId===4)&&(tab===1||tab===2)}>
                            <Button className='edit-button-style'
                                icon={<AgrialertCopyIcon />}
                                onClick={()=>copyTemplateBtn(record)}>
                                <span className='edit-span-style'>Copy</span>
                            </Button>
                        </IF>
                        <IF show={((currentRoleId===1)&&(tab===1))
                            ||((currentRoleId===4)&&(tab===1)&&(text===currentUserId))
                            ||((currentRoleId===1||currentRoleId===4)&&(tab===2))}>
                            <Button className='edit-button-style' icon={<AgrialertEditIcon />}
                                onClick={()=>{
                                    //history.pushState(null,null,'edit');
                                    editTemplateBtn(record);
                                }}
                            >
                                <span className='edit-span-style'>Edit</span>
                            </Button>
                            <Button className='edit-button-style'
                                icon={<AgrialertDeleteIcon />}
                                onClick={()=>deleteTempOnclick(record)}>
                                <span className='edit-span-style'>Delete</span>
                            </Button>
                        </IF>
                        <IF show={(currentRoleId===4)&&(text!=currentUserId)&&(tab===1)}>
                            <Button className='disabled-button' icon={<AgrialertEditDisabledIcon />}>
                                <span className='disabled-span-style'>Edit</span>
                            </Button>
                            <Button className='disabled-button'
                                icon={<AgrialertDeleteDisabledIcon />}
                            >
                                <span className='disabled-span-style'>Delete</span>
                            </Button>
                        </IF>
                        <IF show={tab===3}>
                            <Button className='subscribe-button-style'
                                onClick={()=>subscribeOnClick(record)}>
                                <span className='subscribe-span-style'>Subscribe</span>
                            </Button>
                        </IF>
                    </div>
                ),
            }
        ];
        return columns;
    },[currentRoleId,tab]);

    const columnsForSub = useMemo(()=>{
        const columns = [
            {
                title: 'Name of the Subscription',
                dataIndex: 'subscriptionName',
                key: 'subscriptionName',
                sorter: (a, b) => a.subscriptionName.localeCompare(b.subscriptionName),
                render: (text, record, index) =>
                    <a className='name-text' onClick={e => editItemForSub(record)}>{text}</a>
            },
            {
                title: 'Date Subscribed',
                dataIndex: 'subscribedDate',
                sorter: (a, b) => new Date(a.subscribedDate).getTime() - new Date(b.subscribedDate).getTime(),
                render: (_, { subscribedDate }) => {
                    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                    const date = new Date(subscribedDate);
                    const year = date.getFullYear().toString().slice(-2);
                    const monthIndex = date.getMonth();
                    const monthAbbrev = months[monthIndex];
                    const day = date.getDate().toString().padStart(2, '0');
                    return `${day}-${monthAbbrev}-${year}`;
                }
            },
            {
                title: 'Subscribed By',
                dataIndex: 'subscribedByUserName',
                key: 'subscribedByUserName',
                sorter: (a, b) => a.subscribedByUserName.localeCompare(b.subscribedByUserName),
            },
            {
                title: 'Email Recipients',
                dataIndex: 'toEmails',
                key: 'toEmails',
                // className: tab === 1 ? 'hide-column' : 'to-email-column',
                sorter: (a, b) => a?.toEmails?.localeCompare(b?.toEmails),
            },
            {
                title: '',
                dataIndex: 'subscribedByUserId',
                key: 'subscribedByUserId',
                render: (text, record, index) => (
                    <div className='txt-right'>
                        <IF show={((currentRoleId===1)&&(tab===4))
                            ||((currentRoleId===4)&&(tab===4)&&(text===currentUserId))
                            ||((currentRoleId===3)&&(tab===5))}>
                            <Button className='subscribe-button-red'
                                onClick={()=>unSubscribeOnClick(record)}>
                                <span className='subscribe-span-red'>Unsubscribe</span>
                            </Button>
                            <Button className='subscribe-button-style'
                                onClick={()=>modifySubscribeOnClick(record)}>
                                <span className='subscribe-span-style'>Modify Subscription</span>
                            </Button>
                        </IF>
                        <IF show={(currentRoleId===4)&&(text!=currentUserId)&&(tab===4)}>
                            <Button className='subscribe-button-style'
                                onClick={()=>viewSubscribeOnClick(record)}>
                                <span className='subscribe-span-style'>View</span>
                            </Button>
                        </IF>
                    </div>
                ),
            },
        ];
        return columns;
    },[currentRoleId,tab]);

    const getCurrentRole= async () => {
        const currentUser = await agriAlertGetCurrentUser('agri alert');
        //console.log('666currentRoleId:',currentRoleId);
        //console.log('666currentUser:',currentUser.data.roleId);
        if(currentRoleId ===null){
            //console.log('666currentRoleId is null');
            return currentUser.data.roleId;
        }
    };
    const initTabWhenRefresh= async () => {
        //console.log('444initTabWhenRefreshcurrentRoleId:',currentRoleId);
        //console.log('444initTabWhenRefreshinitTab:',initTab);
        if(initTab===null){
            const initRoleWhenRefresh=await getCurrentRole();
            console.log('666currentinitRoleWhenRefresh',initRoleWhenRefresh);
            if((initRoleWhenRefresh===1)||(initRoleWhenRefresh===4))
            {
                setTab(1);
                dispatch(updateTab(Number(1)));
            }
            if(initRoleWhenRefresh===3)
            {
                setTab(3);
                dispatch(updateTab(Number(3)));
            }
        }
    };

    useEffect(()=>{
        setTab(initTab);
    },[selectedTemplateType]);

    //search
    const searchKeyDown = async (e) => {
        console.log(e);
        setSearchText(e);
        getActiveSubscription(e);
        getTemplateLists(e);
        getMySubscription(e);
        getMyTemplate(e);
    };

    const [loading, setLoading] = useState<boolean>(false);
    const [editableFooterContent,setEditableFooterContent]=useState('');
    const editItem = async (param) => {
        setLoading(true);
        const res=await getTemplateDetail(param.templateId);
        if(typeof res.data === 'object' && res.data !== null){
            console.log('template:',res.data);
            dispatch(updatePreviewDetails(
                {
                    templateName: res.data.templateName,
                    // templateDate: res.data.templateCreateTime,
                    templateDate: res.data.todayLocalTime,
                    templateBannerList: res.data.reportBanner?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                    templateDescription: res.data.reportMessage,
                    templateLocationName: res.data.locationList[0].locationName,
                    templateLat: res.data.locationList[0].lat,
                    templateLng: res.data.locationList[0].lng,
                    // for historical and forecast
                    isShowHistoricalChart: res.data.isShowHistoricalChart,
                    isShowForecastChart: res.data.isShowForecastChart,
                    isShowForecastTable: res.data.isShowForecastTable,
                    isShowForecastTableHourly: res.data.isShowForecastTableHourly,
                    historicalAggregation: res.data.historicalAggregation,
                    historicalDays: res.data.historicalDays,
                    historicalVariables: res.data.historicalVariables?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                    forecastVariables: res.data.forecastVariables?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                    forecastTableDailyVariables: res.data.forecastTableDailyVariables?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                    forecastTableHourlyVariables: res.data.forecastTableHourlyVariables?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                    forecastChartVariables: res.data.forecastChartVariables?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                    // for spray
                    isShowSpray: res.data.isShowSpray,
                    sprayType: res.data.sprayType?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                    languageCode: res.data.reportLanguageCode,
                    reportUnit: res.data?.unit,
                    editableFooter:res?.data?.editableFooter,
                    // for agronomic
                    isShowAgronomic: res?.data?.isShowAgronomic,
                    agronomic: res?.data?.agronomicRecommendations,
                    historicalCharts: res?.data?.historicalCharts,
                    forecastCharts: initForecastChartOrTableFromApiData(res?.data?.forecastCharts,null),
                    forecastTables: initForecastChartOrTableFromApiData(res?.data?.forecastTables,null),
                }
            ));
            setEditableFooterContent(res?.data?.editableFooter);
        }

        setLoading(false);
        setIsShowPreview(true);
    };

    const initForecastChartOrTableFromApiData = (data?: IForecastChartOrTableModel[],type?:string):IForecastChartOrTableModel[]=>{
        const tmpForecast:IForecastChartOrTableModel[] = [];
        if(data?.length >= 1) {

            data?.forEach((item,index)=>{
                const tmpItem:IForecastChartOrTableModel = {
                    sortNumber: index,
                    aggregation: item?.aggregation,
                    variables: item?.variables,
                    variablesForArray: item?.variables?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                    forecastDays: item?.forecastDays
                };
                tmpForecast.push(tmpItem);
            });
        }
        return tmpForecast;
    };

    const editItemForSub = async (param) => {
        setLoading(true);
        console.log('666param:',param);
        const res=await getSubscriptionDetail(param.subscriptionId);
        if(typeof res.data === 'object' && res.data !== null){
            console.log('sub:',res.data);
            dispatch(updatePreviewDetails(
                {
                    templateName: res.data.subscriptionName,
                    // templateDate: res.data.templateCreateTime,
                    templateDate: res.data.todayLocalTime,
                    templateBannerList: res.data.reportBanner?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                    templateDescription: res.data.reportMessage,
                    templateLocationName: res.data.locationList[0].locationName,
                    templateLat: res.data.locationList[0].lat,
                    templateLng: res.data.locationList[0].lng,
                    // for historical and forecast
                    isShowHistoricalChart: res.data.isShowHistoricalChart,
                    isShowForecastChart: res.data.isShowForecastChart,
                    isShowForecastTable: res.data.isShowForecastTable,
                    isShowForecastTableHourly: res.data.isShowForecastTableHourly,
                    historicalAggregation: res.data.historicalAggregation,
                    historicalDays: res.data.historicalDays,
                    historicalVariables: res.data.historicalVariables?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                    forecastVariables: res.data.forecastVariables?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                    forecastTableDailyVariables: res.data.forecastTableDailyVariables?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                    forecastTableHourlyVariables: res.data.forecastTableHourlyVariables?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                    forecastChartVariables: res.data.forecastChartVariables?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                    // for spray
                    isShowSpray: res.data.isShowSpray,
                    sprayType: res.data.sprayType?.split(';')?.filter(x => x != '' && x != undefined && x != null),
                    languageCode: res.data.reportLanguageCode,
                    editableFooter:res?.data?.editableFooter,
                    reportUnit: res?.data?.unit,
                    // for agronomic
                    isShowAgronomic: res?.data?.isShowAgronomic,
                    agronomic: res?.data?.agronomicRecommendations,
                    historicalCharts: res?.data?.historicalCharts,
                    forecastCharts: initForecastChartOrTableFromApiData(res?.data?.forecastCharts,null),
                    forecastTables: initForecastChartOrTableFromApiData(res?.data?.forecastTables,null)
                }
            ));
            setEditableFooterContent(res?.data?.editableFooter);
        }
        setLoading(false);
        setIsShowPreview(true);
    };

    const [copyTempID,setCopyTempID]=useState<number>();
    const [copyTempName,setCopyTempName]=useState<number>();
    const copyTemplateBtn = async (record) => {
        setCopyModalOpen(true);
        setCopyTempID(record.templateId);
        setCopyTempName(record.templateName);
        console.log('666copyTemplateBtn:',record);
    };

    const editTemplateBtn=async(record)=>{
        setLoading(true);
        const res=await getTemplateDetail(record.templateId);
        //console.log('666res:',res.data);
        dispatch(updateTemplateType(TemplateEnumType.EDITTEMPLATE));
        dispatch(updateTempDetails(res.data));
        setLoading(false);
    };
    const subscribeOnClick=async(record)=>{
        //console.log('666ressubscribeOnClick:',record);
        const res=await getTemplateDetail(record.templateId);
        dispatch(updateTemplateType(TemplateEnumType.SUBSCRIBE));
        dispatch(updateTempDetails(res.data));
    };


    const[subscribeName,setSubscribeName]=useState('');
    const [unsubscribeModelOpen,setUnsubscribeModelOpen]=useState(false);
    const [unsubsSuccessuModelOpen,setUnsubsSuccessuModelOpen]=useState(false);
    const [subscriptionId,setSubscriptionId]=useState<number>();
    const unSubscribeOnClick=async(record)=>{
        console.log('666unSubscribeOnClick:',record);
        setSubscribeName(record.subscriptionName);
        setSubscriptionId(record.subscriptionId);
        setUnsubscribeModelOpen(true);
    };
    const modifySubscribeOnClick=async(record)=>{
        console.log('666modifySubscribeOnClick:',tab);
        setLoading(true);
        const res=await getSubscriptionDetail(record.subscriptionId);
        setLoading(false);
        dispatch(updateTemplateType(TemplateEnumType.MODIFYSUBSCRIBE));
        dispatch(updateSubscriptionDetails(res.data));
    };
    //viewSubscribeOnClick
    const viewSubscribeOnClick=async(record)=>{
        setLoading(true);
        const res=await getSubscriptionDetail(record.subscriptionId);
        setLoading(false);
        dispatch(updateTemplateType(TemplateEnumType.VIEWSUBSCRITION));
        dispatch(updateSubscriptionDetails(res.data));
    };

    const initializeTab=async () => {
        if(currentRoleId==1||currentRoleId==4){
            setIsShowAllTemp(true);
            setIsShowMyTemp(true);
            setIsShowAllSub(true);
            setIsShowAvaSub(true);
            setIsShowMySub(false);
        } else if(currentRoleId==3){
            setIsShowAllTemp(false);
            setIsShowMyTemp(false);
            setIsShowAllSub(true);
            setIsShowAvaSub(false);
            setIsShowMySub(true);
        }
        else {
            setIsShowAllTemp(false);
            setIsShowMyTemp(false);
            setIsShowAllSub(false);
            setIsShowAvaSub(false);
            setIsShowMySub(false);
        }
    };

    const getTemplateLists = async (param = searchText, page = pageIndex) => {
        try {
            const res = await getAllTemplates({
                searchText: param,
                isOrderByTemplateNameDesc: false,
                isOrderByDateDesc: true,
                isOrderByCreatorDesc: false,
                pageIndex: 0,
                pageSize: 30 * page,
            });
            setTempList(res);
            setGetTemplateListFlag(true);
        } catch (err) {
            console.log(err);
            setGetTemplateListFlag(true);
        }
    };
    const getMyTemplate = async (param = searchText, page = pageIndex) => {
        try {
            const res = await getMyTemplates({
                searchText: param,
                isOrderByTemplateNameDesc: false,
                isOrderByDateDesc: true,
                isOrderByCreatorDesc: false,
                pageIndex: 0,
                pageSize: 30 * page,
            });
            setMyTempList(res);
            setMyTemplateFlag(true);
        } catch (err) {
            console.log(err);
            setMyTemplateFlag(true);
        }
    };

    const getActiveSubscription = async (param = searchText, page = pageIndex) => {
        try {
            setLoading(true);
            const res = await getActiveSubscriptions({
                searchText: param,
                isOrderByTemplateNameDesc: false,
                isOrderByDateDesc: true,
                isOrderByTempCreatorDesc:false,
                isOrderBySubCreatorDesc: false,
                pageIndex: 0,
                pageSize: 30 * page,
            });
            setAvaSubscriptionsListList(res);
            setLoading(false);
            setActiveSubscriptionFlag(true);
        } catch (err) {
            console.log(err);
            setActiveSubscriptionFlag(true);
        }
    };
    const getMySubscription = async (param = searchText, page = pageIndex) => {
        setLoading(true);
        try {
            const res = await getMySubscriptions({
                searchText: param,
                isOrderByTemplateNameDesc: false,
                isOrderByDateDesc: true,
                isOrderByTempCreatorDesc:false,
                isOrderBySubCreatorDesc: false,
                pageIndex: 0,
                pageSize: 30 * page,
            });
            setMySubscriptionsListList(res);
            setLoading(false);
            setMySubscriptionFlag(true);
        } catch (err) {
            console.log(err);
            setMySubscriptionFlag(true);
        }
    };

    const getAllBanner = async () => {
        const response = await getAllBanners();
        dispatch(updateAllBanner(response.data));
    };

    useEffect(() => {
        // initializeTab();
        getTemplateLists();
        getActiveSubscription();
        getMySubscription();
        getMyTemplate();
        initTabWhenRefresh();
        // get all Banner
        getAllBanner();
    }, []);

    useEffect(() => {
        initializeTab();
    },[currentRoleId]);

    const onChangeforTabs = (key) => {
        setTab(Number(key));
        dispatch(updateTab(Number(key)));
    };

    //delete model
    const [open, setOpen] = useState(false);
    const showModal = () => {
        setOpen(true);
    };

    const hideModal = () => {
        setOpen(false);
    };
    const [currentTempId,setCurrentTempId]=useState();
    const [currentTempName,setCurrentTempName]=useState<string>();
    const [currentSubId,setCurrentSubId]=useState();
    const [currentSubName,setCurrentSubName]=useState<string>();
    const deleteTempOnclick=(record)=>{
        setOpen(true);
        setCurrentTempId(record?.templateId);
        setCurrentTempName(record?.templateName);
        setCurrentSubId(record?.subscriptionId);
        setCurrentSubName(record?.subscriptionName);
    };

    const deleteConfirmTempOnclick=async ()=>{
        setOpen(false);
        const updateCurrentTempId: deleteTemplateReqModel = { templateId: currentTempId};
        const res=await deleteTemplate(updateCurrentTempId);
        if(res==='Success'){
            dispatch(updateSuccessMessage('Delete sucessfully'));
            getTemplateLists();
            getMyTemplate();
        }
        else
            dispatch(updateWarningMessage(res));
    };

    const unsubscribeConfirmOnclick=async ()=>{
        setUnsubscribeModelOpen(false);
        const updateCurrentSubscriptionId: deleteSubscriptionReqModel = { subscriptionId: subscriptionId};
        const res=await deleteSubscription(updateCurrentSubscriptionId);
        if(res==='Success'){
            setUnsubsSuccessuModelOpen(true);
            getActiveSubscription();
            getMySubscription();
        }
        else
            dispatch(updateWarningMessage(res));
    };

    const [copyModelName,setCopyModelName]=useState<string>('');
    const copyModelNameOnChange=(e)=>{
        console.log('666copyModelName',e.target.value);
        setCopyModelName(e.target.value);
    };
    const [copyModalOpen,setCopyModalOpen]=useState<boolean>(false);
    const copyModalCancel=()=>{
        setCopyModalOpen(false);
    };

    const [resultTempId,setResultTempId]=useState<number>();
    const copyModalSave=async()=>{
        console.log('666copyModelName:',copyModelName);
        if(copyModelName===''){
            dispatch(updateWarningMessage('Please enter a different name'));
        }else{
            const checkIsValidName =await checkIsValidTempOrSubName(copyModelName);
            console.log('666checkIsValidName:',checkIsValidName);
            if(checkIsValidName.data){
                const res=await copyTemplate({
                    templateId:copyTempID,
                    strTemplateName:copyModelName
                });
                if(res.result==='Success'){
                    setResultTempId(res.newTemplateId);
                    setSuccessModelOpen(true);
                }
            }else{
                dispatch(updateWarningMessage('The new template name already exists,please rename it'));
                return;
            }
        }
    };
    const [successModelOpen,setSuccessModelOpen]=useState<boolean>(false);
    const hideSuccessModal=async()=>{
        setSuccessModelOpen(false);
        setCopyModalOpen(false);
        setLoading(true);
        const res=await getTemplateDetail(resultTempId);
        dispatch(updateTemplateType(TemplateEnumType.EDITTEMPLATE));
        dispatch(updateTempDetails(res.data));
        setLoading(false);
    };

    const [isShowCreateTempBtn,setIsShowCreateTempBtn]=useState<boolean>(true);
    const showCreateTempBtn=()=>{
        if(tab===1||tab===2){
            setIsShowCreateTempBtn(true);
        }else{
            setIsShowCreateTempBtn(false);
        }
    };
    useEffect(()=>{
        showCreateTempBtn();
    },[tab]);

    // windowHeight
    const [windowHeight, setWindowHeight] = useState(0);
    useEffect(() => {
        setWindowHeight(window.innerHeight);
        const handleResize = () => {
            setWindowHeight(window.innerHeight);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    //preview
    const [isShowPreview, setIsShowPreview] = useState(false);
    const childChangeShowPreview = ()=>{
        setIsShowPreview(false);
    };
    //load data
    const [isFetching, setIsFetching] = useState(false);
    useEffect(() => {
        window.addEventListener('scroll', () => handleScrollDebounce());
        return () => window.removeEventListener('scroll', () => handleScrollDebounce());
    }, []);
    const handleScrollDebounce = debounce(()=>{
        if (window.innerHeight + document.documentElement.scrollTop > document.body.scrollHeight - 50) {
            console.log('fech more items', pageIndex);
            setIsFetching(true);
        } else {
            console.log('unreach');
        }
    },100);
    const [getTemplateListsFlag,setGetTemplateListFlag] = useState(false);
    const [getActiveSubscriptionFlag,setActiveSubscriptionFlag] = useState(false);
    const [getMySubscriptionFlag,setMySubscriptionFlag] = useState(false);
    const [getMyTemplateFlag,setMyTemplateFlag] = useState(false);

    useEffect(()=>{
        if(getTemplateListsFlag && getActiveSubscriptionFlag && getMySubscriptionFlag && getMyTemplateFlag){
            setIsFetching(false);
            setGetTemplateListFlag(false);
            setActiveSubscriptionFlag(false);
            setMySubscriptionFlag(false);
            setMyTemplateFlag(false);
        }
    },[getTemplateListsFlag,getActiveSubscriptionFlag,getMySubscriptionFlag,getMyTemplateFlag]);


    useEffect(() => {
        if (!isFetching) return;
        setpageIndex(pageIndex + 1);
        getTemplateLists(searchText, pageIndex + 1);
        getActiveSubscription(searchText, pageIndex + 1);
        getMySubscription(searchText, pageIndex + 1);
        getMyTemplate(searchText, pageIndex + 1);
    }, [isFetching]);
    return(
        <Spin spinning={loading}>
            <div className="template-list-container">
                <div className='head-div'>
                    <HeaderSearchAgrialert GetAnalyses={searchKeyDown} placeholder='Search' />
                    <IF show={isShowCreateTempBtn} >
                        <Button
                            className='create-template-btn'
                            onClick={()=>{
                                dispatch(updateTemplateType(TemplateEnumType.CREATETEMPLATE));
                            }} >
                            Create Template
                        </Button>
                    </IF>
                </div>
                <Tabs
                    defaultActiveKey="1"
                    activeKey={tab?.toString()}
                    onChange={onChangeforTabs}
                    style={{width:'100%'}}
                >
                    {isShowAllTemp && (
                        <Tabs.TabPane tab="All Template" key="1">
                            <div className='div-table' >
                                <Table
                                    dataSource={tempList}
                                    columns={columnForTemp}
                                    pagination={false} />
                            </div>
                        </Tabs.TabPane>
                    )}
                    {isShowMyTemp && (
                        <Tabs.TabPane tab="My Template" key="2">
                            <div className='div-table'>
                                <Table dataSource={myTempList} columns={columnForTemp} pagination={false} />
                            </div>
                        </Tabs.TabPane>
                    )}
                    {isShowAllSub && (
                        <Tabs.TabPane tab="All Subscriptions" key="3">
                            <div className='div-table' >
                                <Table dataSource={tempList} columns={columnForTemp} pagination={false} />
                            </div>
                        </Tabs.TabPane>
                    )}
                    {isShowAvaSub && (
                        <Tabs.TabPane tab="Available Subscriptions" key="4">
                            <div className='div-table'>
                                <Table dataSource={avaSubscriptionsList} columns={columnsForSub} pagination={false} />
                            </div>
                        </Tabs.TabPane>
                    )}
                    {isShowMySub && (
                        <Tabs.TabPane tab="My Subscriptions" key="5">
                            <div className='div-table'>
                                <Table dataSource={myScriptionsList} columns={columnsForSub} pagination={false} />
                            </div>
                        </Tabs.TabPane>
                    )}
                </Tabs>
                <Modal
                    open={open}
                    onOk={hideModal}
                    onCancel={hideModal}
                    // okText="Delete"
                    cancelText="Cancel"
                    width={708}
                    closable={false}
                    className='delete-modal'
                    footer={
                        <div>
                            <Button type="default" onClick={hideModal}>
                            Cancel
                            </Button>
                            <Button type="primary" onClick={deleteConfirmTempOnclick}>
                            Delete
                            </Button>
                        </div>
                    }
                >

                    <AgrialertUserManagementDeleteSvg />
                    <p className='first-line-style'>Are you sure you want to remove <br />
                        <span className='second-line-style'>&apos;{currentTempName}&apos;?</span></p>
                </Modal>
                <Modal
                    open={copyModalOpen}
                    onOk={copyModalCancel}
                    onCancel={copyModalCancel}
                    okText="Delete"
                    cancelText="Cancel"
                    width={708}
                    closable={false}
                    className='confirm-delete-modal'
                    footer={
                        <div>
                            <Button type="default" onClick={copyModalCancel}>
                            Cancel
                            </Button>
                            <Button type="primary" onClick={copyModalSave} style={{backgroundColor:'#59B948'}}>
                                <span style={{color:'#FFFFFF'}}>Save</span>
                            </Button>
                        </div>
                    }>
                    <AgrialertTemplateCopySvg />
                    <p className='first-line-style'>Before copying the template enter a different name to<br />
                        <span className='second-line-style'>&apos;{copyTempName}&apos;</span></p>

                    <div style={{textAlign:'left',width:'70%',margin:'0 auto'}}>
                        <p>Name</p>
                        <Input size='large'
                            onChange={copyModelNameOnChange}
                            value={copyModelName}
                        />
                    </div>
                </Modal>
                <Modal
                    open={successModelOpen}
                    width={708}
                    closable={false}
                    className='delete-modal'
                    footer={
                        <div>
                            <Button type="default" onClick={hideSuccessModal}>
                            Close
                            </Button>
                        </div>
                    }
                >
                    <AgrialertUserManagementSuccessSvg />
                    <p className='second-line-style'>&apos;{copyTempName}&apos;<br />
                        <span className='first-line-style'>Copied Successfully</span></p>
                </Modal>
                <Modal
                    open={unsubscribeModelOpen}
                    onOk={()=>setUnsubscribeModelOpen(false)}
                    onCancel={()=>setUnsubscribeModelOpen(false)}
                    cancelText="Cancel"
                    width={908}
                    closable={false}
                    className='delete-modal'
                    footer={
                        <div>
                            <Button type="default" onClick={()=>setUnsubscribeModelOpen(false)}>
                            Cancel
                            </Button>
                            <Button type="primary" onClick={unsubscribeConfirmOnclick}>
                        Unsubscribe
                            </Button>
                        </div>
                    }
                >

                    <AgrialertUserManagementDeleteSvg />
                    <p className='first-line-style'>Are you sure you want to Unsubscribe <br />
                        <span className='second-line-style'>&apos;{subscribeName}&apos;?</span></p>
                </Modal>
                <Modal
                    open={unsubsSuccessuModelOpen}
                    width={908}
                    closable={false}
                    className='delete-modal'
                    footer={
                        <div>
                            <Button type="default" onClick={()=>setUnsubsSuccessuModelOpen(false)}>
                            Close
                            </Button>
                        </div>
                    }
                >
                    <AgrialertUserManagementSuccessSvg />
                    <p className='second-line-style'>&apos;{subscribeName}&apos;<br />
                        <span className='first-line-style'>Unsubscribed Successfully</span></p>
                </Modal>
                <IF show={isShowPreview}>
                    <TemplatePreview
                        editableFooterContent={editableFooterContent}
                        modalOpen={isShowPreview}
                        title="Agri-Alert-Template_2024-07-12"
                        changeModalOpenCallback={childChangeShowPreview}
                    />
                </IF>
            </div>
        </Spin>
    );
};

export default TemplateList;